class StickyAddToCart {
    constructor(buttonSelector) {
        this.mainButton = document.querySelector(buttonSelector);
        if (!this.mainButton) {
            console.warn("StickyAddToCart: Butonul principal nu a fost găsit.");
            return;
        }

        this.createStickyButton();
        this.initObserver();
    }

    createStickyButton() {
        this.stickyBar = document.createElement("div");
        this.stickyBar.classList.add("sticky-add-to-cart", "sticky-hidden");

        this.stickyBar.innerHTML = `
            <button id="stickyAddToCart" class="btn btn-primary">Adauga in cos</button>
        `;

        document.body.appendChild(this.stickyBar);
        this.stickyButton = this.stickyBar.querySelector("#stickyAddToCart");

        this.stickyButton.addEventListener("click", () => this.handleStickyClick());
    }

    initObserver() {
        const observerOptions = {
            root: null, 
            threshold: 0.1, 
        };

        this.observer = new IntersectionObserver((entries) => {
            const entry = entries[0];

            if (entry.isIntersecting) {
                this.hideStickyButton();
            } else {
                this.showStickyButton();
            }
        }, observerOptions);

        this.observer.observe(this.mainButton);
    }

    showStickyButton() {
        this.stickyBar.classList.remove("sticky-hidden");
        this.stickyBar.classList.add("sticky-visible");
    }

    hideStickyButton() {
        this.stickyBar.classList.remove("sticky-visible");
        this.stickyBar.classList.add("sticky-hidden");
    }

    handleStickyClick() {
        this.mainButton.click(); 
    }
}


document.addEventListener("DOMContentLoaded", () => {
  console.log('stickyATC');
    new StickyAddToCart(".btn--primary");
});
